import React from "react";
import PropTypes from "prop-types";
import { StyledTooltip } from "./styled";

/**
 * ContextualDnfbpHelp component provides tooltip functionality for DNFBP help text
 * @param {Object} props - Component props
 * @returns {React.ReactElement} React component
 */
export const ContextualDnfbpHelp = ({
  children,
  title = "",
  placement = window.innerWidth < 600 ? "top" : "left",
  isDisableHoverListener = true,
  onClose = null,
  open = undefined
}) => {
  if (!title) {
    return children;
  }

  return (
    <StyledTooltip
      disableHoverListener={isDisableHoverListener}
      placement={placement}
      title={title}
      enterTouchDelay={0}
      leaveTouchDelay={10000}
      leaveDelay={0}
      onClose={onClose}
      open={open}
    >
      {children}
    </StyledTooltip>
  );
};

ContextualDnfbpHelp.propTypes = {
  /** Child elements to wrap with tooltip */
  children: PropTypes.node.isRequired,
  /** Text content to display in the tooltip */
  title: PropTypes.node,
  /** Position of the tooltip relative to the target */
  placement: PropTypes.oneOf([
    "bottom-end",
    "bottom-start",
    "bottom",
    "left-end",
    "left-start",
    "left",
    "right-end",
    "right-start",
    "right",
    "top-end",
    "top-start",
    "top"
  ]),
  /** Whether to disable showing the tooltip when hovering over the target */
  isDisableHoverListener: PropTypes.bool,
  /** Function called when the tooltip is closed */
  onClose: PropTypes.func,
  /** Controls whether the tooltip is displayed */
  open: PropTypes.bool
};
